import React, { useEffect, useState } from "react";
import { Upload, Button, List, Card, message, Popconfirm, Space } from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { getConfig } from "../config";

interface UploadedImage {
  name: string;
}

const ImageManager: React.FC = () => {
  const [images, setImages] = useState<UploadedImage[]>([]);
  const [loading, setLoading] = useState(false);

  // Fetch existing images
  const fetchImages = async () => {
    try {
      console.log("YESS");

      const res = await axios.get<string[]>(`/images`);
      console.log("NO");

      setImages(res.data.map((name) => ({ name })));
    } catch (err) {
      message.error("Failed to fetch images");
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // Upload new image
  const handleUpload = async (options: any) => {
    const { file } = options;
    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      await axios.post(`/images/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      message.success("Image uploaded!");
      fetchImages();
    } catch (err: any) {
      message.error(err.response?.data || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  // Update an existing image by ID
  const handleUpdate = async (id: number, file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      await axios.put(`/images/update/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      message.success(`Image ${id} updated!`);
      fetchImages();
    } catch (err: any) {
      message.error(err.response?.data || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  // Delete an image by ID
  const handleDelete = async (id: number) => {
    try {
      setLoading(true);
      await axios.delete(`/images/delete/${id}`);
      message.success(`Image ${id} deleted!`);
      fetchImages();
    } catch (err: any) {
      message.error(err.response?.data || "Delete failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "auto" }}>
      <h2>Image Manager</h2>

      {/* Upload new image */}
      <Upload customRequest={handleUpload} showUploadList={false}>
        <Button icon={<UploadOutlined />} loading={loading}>
          Upload New Image
        </Button>
      </Upload>

      {/* Show uploaded images */}
      <List
        grid={{ gutter: 16, column: 3 }}
        dataSource={images}
        renderItem={(item) => {
          const id = parseInt(item.name.split(".")[0]); // filename like "1.jpg"
          return (
            <List.Item>
              <Card
                title={`Image ${id}`}
                cover={
                  <img
                    alt={item.name}
                    src={`${getConfig().BASE_URL_API}/api/images/${item.name}`}
                    style={{ height: 150, objectFit: "cover" }}
                  />
                }
                actions={[
                  <Upload
                    showUploadList={false}
                    customRequest={({ file }) => handleUpdate(id, file as File)}
                  >
                    <Button
                      type="link"
                      icon={<EditOutlined />}
                      loading={loading}
                    >
                      Replace
                    </Button>
                  </Upload>,

                  <Popconfirm
                    title="Are you sure you want to delete this image?"
                    onConfirm={() => handleDelete(id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="link"
                      danger
                      icon={<DeleteOutlined />}
                      loading={loading}
                    >
                      Delete
                    </Button>
                  </Popconfirm>,
                ]}
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default ImageManager;
